import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getSession, sendCallbackParams } from '../../redux/auth/auth.slice';
import { getHighestAvailableUrl } from '../../helpers/urlHelper';

export default function AuthCallback() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const runCallback = async () => {
      try {
        // Step 1: finalize login on server
        await dispatch(sendCallbackParams()).unwrap();
        console.log('Callback params sent');

        // Step 2: fetch the authenticated user
        const session = await dispatch(getSession()).unwrap();

        const authenticatedUser = session?.user;

        const landingUrl = getHighestAvailableUrl(authenticatedUser?.role);

        navigate(landingUrl);
      } catch (err) {
        console.error('Auth failed:', err);
        navigate('/');
      }
    };

    runCallback();
  }, [dispatch, navigate]);

  return <div>Processing authentication...</div>;
}
